module.exports = __webpack_public_path__ + "static/media/log-out-icon-active.48d2cc92.svg";